class SearchResults
    constructor: (el) ->
        @.$el = el
        @.$resultsTextEl = @.$el.querySelector '.search-results__text'
        @.$resultsTextTermEl = null
        @.$searchbar = @.$el.querySelector '.search-results__searchbar'

        @.results = []
        @.resultsText = @.$resultsTextEl?.textContent ? 'Ihre Suche nach ##st## hat folgende Treffer ergeben'
        @.searchTerm = window.appUtils.FindGetParameter 'st'

        @.PrepareElement()
        @.InitEvents()
        @.$el.classList.add 'search-results--bound'
        return

    InitEvents: ->
        return
    
    PrepareElement: ->
        self = @
        if @.resultsText.includes '##st##'
            @.$resultsTextEl.innerHTML = @.resultsText.replace '##s##', '<span class="search-results__text__term"></span>'
            @.$resultsTextTermEl = @.$resultsTextEl.querySelector '.search-results__text__term'
            if @.searchTerm && @.searchTerm != ""
                @.$resultsTextTermEl.textContent = @.searchTerm
                @.$searchbar.dispatchEvent new CustomEvent 'searchbar-set-search-term', {
                    bubbles: false
                    detail: {
                        searchTerm: self.searchTerm
                    }
                }
                @.$el.classList.add 'search-results--loading'
        return

BindSearchResults = ->
    document.querySelectorAll '.search-results:not(.search-results--bound)'
        .forEach (el) ->
            new SearchResults el
            return
    return

window.addEventListener 'bind-components', BindSearchResults